import { render } from "./DojoWebPosPaymentMethod.vue?vue&type=template&id=40e4617b"
import script from "./DojoWebPosPaymentMethod.vue?vue&type=script&lang=js"
export * from "./DojoWebPosPaymentMethod.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__